// extracted by mini-css-extract-plugin
export default {"container":"contect_container__vFbdE","imgdiv":"contect_imgdiv__LmdC7","div2":"contect_div2__jGQLs","content":"contect_content__edEMC","h3":"contect_h3__5DE1L"};